module.exports = __webpack_public_path__ + "static/media/amtc-futures.e221a4a0.jpg";